/**
 * @generated SignedSource<<9ed5c01b78fddf419e024a35d6d6bce1>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type UnlinkInvoiceInput = {
  id?: string | null;
  csrfToken?: string | null;
  socketClientId?: string | null;
  clientMutationId?: string | null;
};
export type UnlinkInvoiceMutation$variables = {
  input: UnlinkInvoiceInput;
};
export type UnlinkInvoiceMutation$data = {
  readonly unlinkInvoice: {
    readonly invoice: {
      readonly xeroId: string | null;
      readonly quickbooksId: number | null;
      readonly economicId: number | null;
      readonly sageIntacctId: string | null;
    } | null;
  } | null;
};
export type UnlinkInvoiceMutation = {
  variables: UnlinkInvoiceMutation$variables;
  response: UnlinkInvoiceMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "xeroId",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "quickbooksId",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "economicId",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "sageIntacctId",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "UnlinkInvoiceMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "UnlinkInvoicePayload",
        "kind": "LinkedField",
        "name": "unlinkInvoice",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "InvoiceType",
            "kind": "LinkedField",
            "name": "invoice",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              (v4/*: any*/),
              (v5/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "UnlinkInvoiceMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "UnlinkInvoicePayload",
        "kind": "LinkedField",
        "name": "unlinkInvoice",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "InvoiceType",
            "kind": "LinkedField",
            "name": "invoice",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              (v4/*: any*/),
              (v5/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "6e2e758d9fb1563144b22302d9782293",
    "id": null,
    "metadata": {},
    "name": "UnlinkInvoiceMutation",
    "operationKind": "mutation",
    "text": "mutation UnlinkInvoiceMutation(\n  $input: UnlinkInvoiceInput!\n) {\n  unlinkInvoice(input: $input) {\n    invoice {\n      xeroId\n      quickbooksId\n      economicId\n      sageIntacctId\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "6c1af8e122635eafedb9017263aeb5ae";

export default node;
